export default __webpack_public_path__ + "static/soehne-mono-web-buch-65769b13dfeb13aadbb3c05673488b30.woff2";